import { useEffect, useRef, useState } from 'react';
import { ICustomItemsOfGroups, TPhotoSize } from 'types';
import { getFilePathForMediaFilesWithSizeForStyleSettings } from 'backend/additionalInformation';

export const useCarouselItemUrl = ({
	item,
	photoSize,
	isMakeRequest,
}: {
	item: ICustomItemsOfGroups;
	photoSize: TPhotoSize;
	isMakeRequest: boolean;
}) => {
	const [url, setUrl] = useState<Nullable<string>>(item.filePath ? null : item.sourceUrl);
	const [isError, setIsError] = useState<boolean>(false);
	const isRequested = useRef<boolean>(false);
	const isMounted = useRef<boolean>(true);

	useEffect(
		() => () => {
			isMounted.current = false;
		},
		[],
	);

	useEffect(() => {
		if (!item.filePath || !isMakeRequest || isRequested.current) {
			return;
		}

		isRequested.current = true;

		const getUrl = async () => {
			try {
				const { data } = await getFilePathForMediaFilesWithSizeForStyleSettings(
					item.translationId,
					item.mediaFileType === 2 ? 'Original' : photoSize,
				);
				if (!isMounted.current) {
					return;
				}
				if (data.preSignedUrl) {
					setUrl(data.preSignedUrl);
				} else {
					setIsError(true);
				}
			} catch {
				if (isMounted.current) {
					setIsError(true);
				}
			}
		};

		getUrl();
	}, [isMakeRequest]);

	const showError = () => {
		setIsError(true);
	};

	return { url, isError, showError };
};
